import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=df5f4118&scoped=true"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=df5f4118&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5f4118",
  null
  
)

export default component.exports